import checkValidEmail from './check-valid-email';
import checkValidPassword from './check-valid-password';
import pushToDataLayer from './push-to-data-layer';
import {
  RESIDENCE_COUNTRIES,
  RESIDENCE_HIGH_REGULATION_COUNTRIES,
  submitSalesforceLead,
  submitSalesforceNewsletter
} from './salesforce-helpers';
import userRoleOptions from './user-role-options';

export {
  checkValidEmail,
  checkValidPassword,
  pushToDataLayer,
  RESIDENCE_COUNTRIES,
  RESIDENCE_HIGH_REGULATION_COUNTRIES,
  submitSalesforceLead,
  submitSalesforceNewsletter,
  userRoleOptions
};
